import React from 'react';
import Styles from '../style';
import { ProfileAvatar } from '../../../../../../../componentsV2/ProfileAvatar';
import { Flex, Spin } from 'antd';
import AdvocacyClassification from '../../../../../../../components/contacts/AdvocacyClassification';
import DecisionMakerTag from '../../../../../../../components/contacts/DecisionMakerTag';
import { format } from 'date-fns';

const { HeaderSection, Subtitle, NameAndTitleFrame, Title } = Styles;

interface Props {
  name: string;
  percentage: number;
  meetings: number;
  attendees: number;
  email: string;
  lastMeeting: string;
  noShows: number;
  role?: string;
  isDecisionMaker: boolean;
  advocacyClassification: string;
  hasProfile: boolean;
  profileLastGenerated: string;
}

export const ContactCardContent: React.FC<Props> = ({
  name,
  email,
  isDecisionMaker,
  advocacyClassification,
  role,
  hasProfile,
  profileLastGenerated,
}) => {
  return (
    <>
      <HeaderSection>
        <ProfileAvatar image={<>{(name || email).slice(0, 1).toUpperCase()}</>} />

        <NameAndTitleFrame>
          <Title>{name || email}</Title>
          {role && <Subtitle>{role}</Subtitle>}
          {hasProfile ? (
            <Subtitle>Generated on {format(new Date(profileLastGenerated), 'MM/dd/yyyy')}</Subtitle>
          ) : (
            <Subtitle>
              <em style={{ color: 'lightgrey' }}>No profile generated yet</em>
            </Subtitle>
          )}
          {(isDecisionMaker || advocacyClassification !== 'None') && (
            <Flex gap={2}>
              {isDecisionMaker && <DecisionMakerTag />}
              {advocacyClassification !== 'None' && (
                <AdvocacyClassification classification={advocacyClassification} />
              )}
            </Flex>
          )}
        </NameAndTitleFrame>
      </HeaderSection>

      {/* <TalkRatioSection>
        <Progress
          percent={percentage}
          showInfo={false}
          strokeColor={colors.primary[500]}
          style={{ margin: '0px', lineHeight: '4px' }}
        />

        <TalkRatioFrame>
          <TalkRatioLabel>Avg. talk ratio</TalkRatioLabel>
          <Percentage>{`${percentage?.toFixed(2) || 0}%`}</Percentage>
        </TalkRatioFrame>
      </TalkRatioSection>

      <MeetingsInfoSection>
        <MeetingInfo>
          <Label>Last meeting</Label>
          <LabelValue>
            {lastMeeting ? format(new Date(lastMeeting), ACCOUNT_DATE_FORMAT) : '-'}
          </LabelValue>
        </MeetingInfo>

        <MeetingInfo>
          <Label>Meetings</Label>
          <LabelValue>{meetings}</LabelValue>
        </MeetingInfo>

        <MeetingInfo>
          <Label>Did not attend</Label>
          <LabelValue>{noShows}</LabelValue>
        </MeetingInfo>
      </MeetingsInfoSection> */}
    </>
  );
};
